export default __webpack_public_path__ + "static/media/logo-3.9431aba6.png";